export default "__VITE_ASSET__CWWN5geV__";